import {BehaviorSubject, finalize, Observable, Subject, Subscriber} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {NotificationService, Notification} from "@pb-labs/notification";
import {fileUploadModalActions} from "../const";
import {SFTPAPIService} from "@app/services/sftp-api/sftp-api.service";

export abstract class FileUploadModalBaseModel {
  protected _fileUploading = false;
  protected _selectedFile$: BehaviorSubject<File>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected _resultSubscriber$: Subscriber<any> = null;
  protected _open$: Subject<void> = null;
  protected _close$: Subject<void> = null;
  protected _destroy$: Subject<void> = null;

  protected abstract sftpAPIService: SFTPAPIService;
  protected abstract notificationService: NotificationService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract startDialog$(value: any): Observable<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract uploadFile(): any;

  initialize(): void {
    this._destroy$ = new Subject<void>();
    this._open$ = new Subject<void>();
    this._close$ = new Subject<void>();
    this._selectedFile$ = new BehaviorSubject<File>(null);
  }

  destroy(): void {
    this.closeUploadModal();

    this._fileUploading = false;
    this._open$.complete();
    this._open$ = null;
    this._close$.complete();
    this._close$ = null;

    this._selectedFile$.next(null);
    this._selectedFile$.complete();
    this._selectedFile$ = null;

    this._destroy$.next();
    this._destroy$.complete();
    this._destroy$ = null;
  }

  get selectedFile$(): Observable<File> {
    return this._selectedFile$.asObservable();
  }

  get open$(): Observable<void> {
    return this._open$.asObservable();
  }

  get close$(): Observable<void> {
    return this._close$.asObservable();
  }

  get isFileUploading(): boolean {
    return this._fileUploading;
  }

  verify(action: fileUploadModalActions): void {
    switch (action) {
      case fileUploadModalActions.Upload:
        this._fileUploading = true;

        this.uploadFile()
          .pipe(
            takeUntil(this._destroy$),
            finalize(() => {
              this._fileUploading = false;
            })
          )
          .subscribe({
            next: (result) => {
              this.handleSuccessUpload(result);
            },
            error: (error) => {
              console.error(error);

              this.notificationService.showError(
                new Notification({
                  message: "Uploading file failed.",
                  timeout: 5000,
                })
              );
            },
          });
        break;

      case fileUploadModalActions.Cancel:
        this.closeUploadModal();
        this._resultSubscriber$.error(undefined);
        break;
    }
  }

  onFileSelect(selectedFile: File): void {
    this._selectedFile$.next(selectedFile);
  }

  clearFile(): void {
    this._selectedFile$.next(null);
    this._fileUploading = null;
  }

  protected handleSuccessUpload(result): void {
    this.closeUploadModal();
    this._resultSubscriber$.next(result);
    this._resultSubscriber$.complete();
  }

  protected closeUploadModal(): void {
    this._fileUploading = false;
    this._close$.next();
    this.clearFile();
  }

  protected _openDialog(): void {
    this._open$.next();
  }
}
